import React from 'react';
import { beautifyNumber } from '../../../../Utils/FormatNumber';

const AccumulatedVatPanel = ({ t, accumulatedVat }) => {
    if (!accumulatedVat) return null;

    const items = [
        { label: t("TransactionsVATDifference"), value: accumulatedVat.vatTransactions },
        { label: t("EquipmentVATDifference"), value: accumulatedVat.equipmentVAT },
        { label: t("OtherInputsVATDifference"), value: accumulatedVat.otherVATTaxes },
        { label: t("TotalDifference"), value: accumulatedVat.netVAT, isTotal: true },
    ];

    return (
        <div className="vat-accumulated-panel">
            <div className="vat-accumulated-panel__title">
                {t("AccumulatedDifferenceInVat")}
            </div>
            <div className="vat-accumulated-panel__items">
                {items.map((item, idx) => (
                    <div key={idx} className={`vat-accumulated-panel__item ${item.isTotal ? 'vat-accumulated-panel__item--total' : ''}`}>
                        <span className="vat-accumulated-panel__label">{item.label}</span>
                        <span className={`vat-accumulated-panel__value ${item.value >= 0 ? 'positive' : 'negative'}`}>
                            {beautifyNumber(item.value)}
                        </span>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default AccumulatedVatPanel;
